module.exports = __webpack_public_path__ + "static/media/draw-connecting-teams.26f7b23c.svg";